export default "__VITE_ASSET__71adb99e__"